
<template>
    <div>
        <loading
                 
                 v-model:active="IsLoading"
                 ref="loader"
                 :can-cancel="false"
                 color="transparent"
                 background-color="white"
                 :opacity="0.8"
                 :is-full-page="true">

            <div v-if="!NavLoaded|| IsLoading" class="overlay" id="loading">
                <div class="d-flex justify-content-center align-items-center" style="height:100%">
                    <div class="spinner-border text-primary" role="status">
                    </div>
                    <br />
                </div>
            </div>

            <!--<div v-if="!NavLoaded" style="display: flex; justify-content: center; align-items: center; height: 100vh; width: 100%;">
                <img style="width:100px;" src="/images/loading.gif" alt="Loading Image" />
            </div>-->

            <!-- Content goes before the "after" slot -->
            <!-- Define the "after" slot using the "v-slot" directive -->
            <template v-slot:after>
                <div style="margin-top:18px;color:white;position:relative;left:-10px;width:50px;"></div>
            </template>
        </loading>
        <div style="margin-bottom:100px;">
            <live-page-root v-if="SelectedPage && NavLoaded" v-bind:selectedpage="SelectedPage"></live-page-root>
        </div>
    </div>
</template>

<style>
   
</style>



<script>  
    //import axios from '/src/components/NovaAxios.js';
    import axios from '/src/components/NovaAxios.js';
    import { ref, nextTick } from 'vue'
    import LivePageRoot from '/src/components/ContentCreator/LivePageRoot.vue';
    import Loading from 'vue-loading-overlay'; 
    import 'vue-loading-overlay/dist/css/index.css';
    import EventHub from '/src/Util/EventHub.js';
    import { useEditorStore } from '/src/stores/EditorStore';
     
    export default {
        name: 'Page',
        data() {
            return {
                NavLoaded: false,
                IsLoading: false,
                SelectedPage: '',
                Store: null,
                PageRendered: false,
            };
        },
        components:
        {
           
            Loading,
            LivePageRoot,
            //NovaDataEditor
        },
        methods:
        {
            PageLoading: function (isLoading) {
                this.IsLoading = isLoading;
            },
            GetUncachedNavMenu: function() {
                var that = this;
                axios.get('/API/UncachedNav', {
                    cache: false
                })
                .then(function (response) {
                    that.IsLoading = false;
                    if (response.status !== 200) {
                        throw new Error("Request failed with status: " + response.status);
                    }
                    
                    var element = document.getElementById('UncachedNav');
                    if (element) {
                        element.innerHTML = response.data;
                    } 
                    that.NavLoaded = true;
                })
                    .catch(function (error) {
                    that.IsLoading = false;
                    that.NavMenuAttempts++;
                    if (that.NavMenuAttempts < 10) {
                        setTimeout(function() {
                            that.GetUncachedNavMenu();
                        }, 5000);
                    }
                });
            }
        },
        computed:
        {
          
        },
        beforeMount: function () {
                              
        },
        mounted: function () {    
            this.Store = useEditorStore();
            EventHub.$on('PageLoading', this.PageLoading);   
            this.IsLoading = true;
            // Get the current URL from the browser's address bar
            const currentURL = window.location.href;

            this.SelectedPage = _SelectedPage;
            this.PageRendered = true;
            this.GetUncachedNavMenu();

            var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
            var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new bootstrap.Tooltip(tooltipTriggerEl)
            })
        },
        beforeUnmount: function () {
            EventHub.$off('PageLoading', this.PageLoading);          

        }
    }
</script>

<style>
    .modal-backdrop {
        z-index: 200 !important;
        background-color: rgba(45, 55, 75, 0.7) !important
    }
</style>